import { CasBaseDialog } from 'src/compass/shared/components';
import ClaimListing, { ClaimColumns, ClaimFilters } from '../shared/ClaimListing/ClaimListing';

export function ClaimOpenDialog({ open, onClose }: any) {
  return (
    <CasBaseDialog open={open} maxWidth="xl" onClose={onClose} title="Select Claim" showCloseIcon>
      <ClaimListing
        defaultOrder="desc"
        initialLoad={false}
        columns={[
          ClaimColumns.endDate,
          ClaimColumns.insuredName,
          ClaimColumns.reinsuranceYear,
          ClaimColumns.policyNumber,
          ClaimColumns.sce,
          ClaimColumns.status,
          ClaimColumns.effectiveDate,
        ]}
        filters={[
          ClaimFilters.insuredNameSearch,
          ClaimFilters.policyNumber,
          ClaimFilters.sce,
          ClaimFilters.insuredName,
        ]}
      />
    </CasBaseDialog>
  );
}
